import { Directive } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS  } from '@angular/forms';
import { numericValidator } from '../validatorFunctions';

@Directive({
  selector: '[gtNumericValidator]',
  providers: [{provide: NG_VALIDATORS, useExisting: NumericValidatorDirective, multi: true}]
})
export class NumericValidatorDirective implements Validator {

  validate(control: AbstractControl): {[key: string]: any} | null {
    return numericValidator()(control);
  }

}
